import Cookies from 'universal-cookie';
import _ from 'lodash';

export const KEY_USER_AUTHORIZATION_STATUS = 'USER_AUTHORIZATION_STATUS';
export const KEY_LAST_NAVIGATED_PATH = 'LAST_NAVIGATED_PATH';

const EXPIRY_DURATION = 365 * 24 * 60 * 60 * 1000; // One year

export const USER_AUTHORIZATION_STATUS = {
  NO_ACCESS: 1,
  UNAUTHORIZED: 2,
  AUTHORIZED: 3,
  NOT_FOUND: 4,
};

let cookie = new Cookies();

export function set(key, value) {
  let date = new Date();
  date.setTime(date.getTime() + EXPIRY_DURATION);

  cookie.set(key, value, { path: '/', expires: date });
}

export function get(key) {
  return cookie.get(key);
}

export function remove(key) {
  cookie.remove(key, { path: '/' });
}

export function removeAll() {
  let cookies = cookie.getAll();
  let cookiesKeys = _.keys(cookies);

  cookiesKeys.forEach((cookieKey) => remove(cookieKey));
}

export function getAll() {
  return cookie.getAll();
}
